import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export function useLanguage() {
  return useContext(LanguageContext);
}

const translations = {
  'zh-CN': {
    // Navbar
    nav: {
      home: '首页',
      about: '关于我们',
      services: '业务范围',
      pricing: '最新报价',
      news: '新闻中心',
      contact: '联系我们',
      careers: '人才招聘',
      downloads: '表格下载',
      credentials: '资质荣誉',
      logoText: '首嘉/深圳瀚阳',
    },
    // Footer
    footer: {
      description:
        '首嘉/深圳瀚阳，专注一站式国际物流解决方案，主打印度、欧美、中东等市场的空运和包机定制化服务，同时提供报关、仓储及供应链管理等服务。',
      quickLinks: '快速链接',
      serviceScope: '核心业务',
      contactUs: '联系我们',
      domestic: '国际货运代理',
      international: '空运',
      warehouse: '仓储配送服务',
      supplyChain: '供应链管理',
      address: '广东省深圳市宝安区福永街道星航中心21A',
      hours: '周一至周日 8:00-18:00',
      copyright: '© 2026 深圳市首嘉运通国际物流有限公司. 保留所有权利.',
      privacy: '隐私政策',
      terms: '服务条款',
      sitemap: '网站地图',
    },
    // Home
    home: {
      heroTitle: '专业国际空运物流 值得信赖',
      heroSubtitle:
        '首嘉/深圳瀚阳 — 100% 空运专业运营 · 印度王牌航线 · 独家Y8全货机包机，连接印度、欧美及全球核心市场',
      contactNow: '立即咨询',
      learnMore: '了解更多',
      advantagesTitle: '我们的优势',
      advantagesSubtitle: '专注国际物流，为您提供高效、可靠的跨境货运服务',
      fastDelivery: '高效运输',
      fastDeliveryDesc:
        '印度、欧美、中东、巴基斯坦核心航线，快速直达，确保货物准时到港',
      safety: '安全保障',
      safetyDesc: '全程保险覆盖，专业包装，实时追踪，确保货物安全送达',
      pricing: '价格透明',
      pricingDesc: '合理透明的报价体系，大宗货物享受更多优惠，节省您的物流成本',
      team: '专业团队',
      teamDesc: '资深国际物流专家团队，7×24小时为您提供专业咨询与跟踪服务',
      coreTitle: '核心业务',
      coreSubtitle: '一站式国际物流解决方案',
      intlFreight: '空运服务',
      intlFreightDesc: '国际航空货运，专业打包，快速清关，港口到港口配送',
      warehouseService: '报关 · 仓储 · 供应链',
      warehouseDesc:
        '专业报关代理、普通货物仓储、装卸搬运及全流程供应链管理服务',
      learnDetails: '了解详情 →',
      yearsExp: '年空运行业经验',
      clients: 'BSA合作航司',
      cities: '自有集货仓库',
      satisfaction: '年货运出口量',
      ctaTitle: '准备好开启您的国际物流之旅？',
      ctaDesc: '联系首嘉/深圳瀚阳，获取专业的物流解决方案和优惠报价',
      getQuote: '获取报价',
      contactUs: '联系我们',
    },
    // About
    about: {
      pageTitle: '关于我们',
      pageSubtitle: '专注国际物流，值得信赖的跨境货运伙伴',
      companyIntro: '公司简介',
      introP1:
        '深圳市首嘉运通国际物流有限公司（简称"首嘉/深圳瀚阳"）为上海瀚阳国际货运代理有限公司旗下深圳分公司。瀚阳集团成立于2004年，旗下逾300名专业员工，深耕空运领域20余年，100% 聚焦空运，专注服务北美、欧洲、印巴、澳新、南非、东南亚等核心市场。',
      introP2:
        '核心业务涵盖：独家波音777全货机包机（Y8，PVG-BOM直飞，每周2班，单班100吨）、BOM 经南京/重庆中转至芝加哥/洛杉矶/阿姆斯特丹/纽瓦克/华沙转口 SPA 航线、BSA 航司代理（3U、GI、O3、JG、MU、CX、JL、SQ、D7等）、自有5,000㎡集货仓库及保税卡车服务。分支机构覆盖深圳、广州、香港、北京、宁波、杭州、福州及洛杉矶。',
      culture: '企业文化',
      mission: '企业使命',
      missionDesc:
        '成为全球可信赖的物流合作伙伴；追求更高的客户满意度；提供及时准确的服务；持续超越，实现互利共赢',
      vision: '企业愿景',
      visionDesc:
        '坚持创新与专业，持续提升服务品质，为客户提供高效、安全、便捷的全球物流解决方案，携手合作伙伴共创繁荣未来',
      values: '核心价值观',
      valuesDesc: '诚信经营、专业高效、创新驱动、合作共赢，以客户价值为核心持续超越',
      history: '发展历程',
      founded: '福州创立',
      foundedDesc:
        '瀚阳集团在福州成立，扎根空运领域，逐步建立专业化国际物流服务体系',
      expansion: '总部迁至上海',
      expansionDesc:
        '公司总部迁至上海，全面升级运营平台，拓展国际空运业务版图',
      upgrade: '广州分公司成立',
      upgradeDesc:
        '广州分公司正式运营，华南区域业务全面布局，持续拓展国内外空运航线资源',
      scale: '美国分公司成立',
      scaleDesc:
        '洛杉矶分公司成立，正式进入北美市场，构建中美双向货运服务能力',
      innovation: '深圳分公司成立',
      innovationDesc:
        '深圳市首嘉运通国际物流有限公司（首嘉/深圳瀚阳）正式成立，深化华南空运及跨境业务，专注印度、欧美、中东等新兴市场',
      partnersTitle: '行业协会认证',
      partnersSubtitle: '获得全球主流货运行业协会认可，依法合规、诚信经营',
      advantages: '我们的优势',
      wideNetwork: '🌐 专业航线',
      wideNetworkDesc: '深耕印度、欧美、中东、巴基斯坦航线，覆盖主要港口，专业高效',
      proTeam: '💼 持证运营',
      proTeamDesc: '持有国际货运代理、无船承运、报关等资质，合规运营',
      security: '🔒 安全保障',
      securityDesc: '全程保险覆盖，实时追踪，确保货物安全准时到达',
      efficient: '⚡ 一站式服务',
      efficientDesc: '空运、报关、仓储、供应链，全流程一站式处理，提供定制化物流解决方案',
      summitTitle: '国际展会足迹',
      summitSubtitle: '积极参与全球货代人峰会，拓展国际合作网络',
      cultureTitle: '团队风采',
      cultureSubtitle: '凝心聚力，共创未来',
    },
    // Services
    services: {
      pageTitle: '业务范围',
      pageSubtitle: '一站式国际物流解决方案',
      intlTitle: '空运服务',
      intlDesc:
        '独家波音777全货机包机（Y8）直飞印度孟买（PVG-BOM），每周2班，单班100吨；同时提供 BOM 经南京/重庆中转至芝加哥、洛杉矶、阿姆斯特丹、纽瓦克、华沙的一单到底 SPA 转口贸易服务。业务覆盖北美、欧洲、印巴、澳新、南非、东南亚等全球核心市场。',
      intlFeatures: [
        '独家Y8 777全货机包机（PVG-BOM，100吨/班，每周2班）',
        'BOM→欧美转口：孟买→南京/重庆→芝加哥/洛杉矶/阿姆斯特丹/华沙',
        'BSA合作航司：3U、GI、O3、JG、MU、CX、JL、SQ、D7等',
        '全球空运集拼服务（Console），多航线平台高效揽货集货',
        '一单到底 SPA 转口贸易，全程保障',
        '覆盖北美、欧洲、印巴、澳新、南非、东南亚',
      ],
      warehouseTitle: '报关代理',
      warehouseDesc:
        '持有正规报关资质，提供进出口报关全流程代理服务，包括单证审核、HS编码归类、税费核算及海关申报，确保货物合规通关，避免延误与罚款。',
      warehouseFeatures: [
        '进出口报关代理',
        '货物及技术进出口',
        '无船承运业务（NVOCC）',
        'HS编码归类咨询',
        '税费预估与优化',
        '全流程单证处理',
      ],
      supplyChainTitle: '仓储 · 搬运 · 供应链',
      supplyChainDesc:
        '提供普通货物仓储服务（不含危化品）、装卸搬运、道路货物运输站经营及全链路供应链管理，助力企业优化库存、降低成本、提升运营效率。',
      supplyChainFeatures: [
        '普通货物仓储（深圳）',
        '海外仓服务',
        'Amazon FBA 头程物流',
        '装卸搬运服务',
        '供应链管理服务',
        '国内贸易代理',
      ],
      industriesTitle: '经营资质',
      industriesSubtitle: '持有以下合法经营资质，依法合规运营',
      manufacturing: '国际货运代理',
      ecommerce: '无船承运业务',
      medical: '报关业务',
      food: '国内货物运输代理',
      electronics: '供应链管理服务',
      clothing: '仓储 · 集装箱租赁',
      allServicesTitle: '全部业务范围',
      allServicesSubtitle: '依法登记的完整经营范围',
      allServices: [
        '国际货运代理',
        '国内货物运输代理',
        '航空运输货物打包服务',
        '国内集装箱货物运输代理',
        '普通货物仓储服务（不含危险化学品等需许可审批的项目）',
        '国内贸易代理',
        '装卸搬运',
        '道路货物运输站经营',
        '供应链管理服务',
        '物联网应用服务',
        '互联网销售（除销售需要许可的商品）',
        '集装箱租赁服务',
        '租赁服务（不含许可类租赁服务）',
        '货物及技术进出口',
        '报关业务',
        '无船承运业务',
      ],
    },
    // Pricing
    pricing: {
      pageTitle: '最新报价',
      pageSubtitle: '透明合理的价格体系，为您节省物流成本',
      noticeTitle: '💡 报价说明',
      notice1:
        '以下报价为参考价格，空运按kg计算',
      notice2: '实际价格因货物类型、重量、体积、旺季等因素有所调整',
      notice3: '大宗货物及长期合作客户享受更多优惠，欢迎联系客服获取专属报价',
      notice4: '报价不含目的港当地费用，具体以合同为准',
      domestic: '✈️ 空运报价',
      international: '✈️ 空运报价',
      origin: '起运地',
      destination: '目的地/港口',
      refPrice: '参考价格',
      estTime: '预计航程',
      calcTitle: '💰 快速询价',
      calcDesc: '填写以下信息，获取详细报价',
      originPlaceholder: '起运地（如：深圳）',
      destPlaceholder: '目的地（如：迪拜）',
      weightPlaceholder: '货物重量（kg）或体积（CBM）',
      goodsType: '货物类型',
      general: '普通货物',
      fragile: '易碎品',
      valuable: '贵重物品',
      coldChain: '危险品（需申报）',
      calculate: '立即询价',
      extraServices: '增值服务',
      packaging: '航空专业打包',
      packagingPrice: '按件报价',
      insurance: '货物保险',
      insurancePrice: '货值的0.3%-0.5%',
      pickup: '上门揽货',
      pickupPrice: '按实际距离报价',
      delivery: '报关代理',
      deliveryPrice: '按票报价',
      customTitle: '需要定制化报价方案？',
      customDesc: '联系首嘉/深圳瀚阳专业客服团队，为您提供最优惠的国际物流方案',
      callNow: '📞 立即致电',
      onlineConsult: '💬 在线咨询',
    },
    // News
    news: {
      pageTitle: '新闻中心',
      pageSubtitle: '了解首嘉/深圳瀚阳最新动态与行业资讯',
      loading: '加载中...',
      noNews: '暂无新闻',
      readMore: '阅读更多 →',
      backToList: '返回新闻列表',
      notFound: '新闻不存在或已下线',
      searchPlaceholder: '搜索新闻标题...',
      searchBtn: '搜索',
      pinned: '置顶',
      categories: {
        '行业资讯': '行业资讯',
        '公司动态': '公司动态',
        '物流知识': '物流知识',
        '政策法规': '政策法规',
      },
    },
    // Careers
    careers: {
      pageTitle: '人才招聘',
      pageSubtitle: '加入首嘉/深圳瀚阳，共同开创国际物流新未来',
      loading: '加载中...',
      noJobs: '暂无招聘信息',
      countUnit: '名',
      nationwide: '全国多地',
      regionLabel: '招聘地区：',
      responsibilities: '岗位职责',
      requirements: '任职要求',
      applyPrefix: '感兴趣请将简历发送至：',
      applyNote: '邮件主题请注明「应聘岗位 - 姓名 - 意向城市」',
    },
    downloads: {
      pageTitle: '表格下载',
      pageSubtitle: '下载最新运价表及相关报价文件',
      loading: '加载中...',
      noFiles: '暂无可下载文件',
      updatedAt: '更新于',
      preview: '预览',
      download: '下载',
      previewUnavailable: '预览功能需要真实文件链接，敬请期待',
      downloadUnavailable: '下载链接暂未配置，敬请期待',
    },
    // Credentials
    credentials: {
      pageTitle: '资质荣誉',
      pageSubtitle: '专业资质认证与行业荣誉，值得信赖',
      certsTitle: '企业资质证书',
      certsSubtitle: '持有合法经营资质，依法合规运营',
      honorTitle: '荣誉奖项',
      honorSubtitle: '行业认可，实力见证',
      airlinesTitle: 'BSA 合作航司',
      airlinesSubtitle: '全球知名航空公司首选合作伙伴',
      customersTitle: '主要客户',
      customersSubtitle: '值得信赖的长期合作伙伴',
      assocTitle: '行业协会会员',
      assocSubtitle: '获得全球主流货运行业协会认可',
    },
    chat: {
      title: '在线客服',
      welcome: '您好！欢迎咨询，有什么可以帮助您的吗？',
      botReply:
        '非常抱歉，您的问题我暂时无法解答，您可以点击{link}联系人工客服',
      linkText: '转人工',
      placeholder: '请输入您的问题…',
      send: '发送',
    },
    // Contact
    contact: {
      pageTitle: '联系我们',
      pageSubtitle: '期待为您提供专业的国际物流服务',
      contactInfo: '联系方式',
      intro:
        '首嘉/深圳瀚阳专业团队随时为您服务，无论您有任何国际物流需求或疑问，欢迎随时与我们联系。',
      hotline: '客服热线',
      hotlineHours: '周一至周日 8:00-18:00',
      email: '电子邮箱',
      emailReply: '24小时内回复',
      address: '公司地址',
      addressValue: '广东省深圳市宝安区福永街道星航中心21A',
      addressNav: '导航搜索"首嘉/深圳瀚阳物流"',
      onlineService: '在线客服',
      wechat: '微信客服：请联系我们获取',
      wechatScan: '扫码添加企业微信',
      businessHours: '营业时间',
      weekdays: '周一至周五',
      weekends: '周六至周日',
      holidays: '法定节假日',
      onDuty: '值班服务',
      onlineConsult: '在线咨询',
      consultDesc: '填写以下表单，我们会尽快与您联系',
      namePlaceholder: '请输入您的姓名',
      phonePlaceholder: '请输入您的手机号码',
      emailPlaceholder: '请输入您的邮箱地址',
      companyPlaceholder: '请输入您的公司名称',
      name: '姓名 *',
      phone: '联系电话 *',
      emailLabel: '电子邮箱',
      company: '公司名称',
      serviceType: '服务类型 *',
      selectService: '请选择服务类型',
      intlService: '空运服务',
      warehouseService: '报关代理',
      supplyChainService: '仓储 / 供应链管理',
      otherService: '其他咨询',
      message: '留言内容 *',
      messagePlaceholder:
        '请描述您的物流需求或问题（货物品名、重量/体积、目的地等）...',
      captchaLabel: '验证码 *',
      captchaPlaceholder: '请输入验证码',
      captchaError: '验证码错误，请重新输入',
      submit: '提交咨询',
      submitting: '提交中...',
      successMsg: '感谢您的咨询！首嘉/深圳瀚阳客服人员会尽快与您联系。',
      failMsg: '提交失败，请稍后重试',
      teamTitle: '联系我们的团队',
      teamAddress: '中国深圳市宝安区福永街道F单元星航中心4号21楼A室',
      location: '公司位置',
      mapLoading: '地图加载中...',
      mapNote: '实际项目中可集成百度地图、高德地图等API',
      mapCompanyName: '深圳市首嘉运通国际物流有限公司/上海瀚阳国际货运代理有限公司深圳分公司',
      mapAddress: '深圳市宝安区福永街道F单元星航中心4号21楼A室',
      mapAddressLabel: '地址',
      phoneError: '请输入有效的手机号码',
      emailError: '请输入有效的邮箱地址',
      privacyNotice: '请阅读并同意隐私协议后再提交',
      privacyCheckbox: '我已阅读并同意',
      privacyLink: '《隐私保护》',
      privacyModalTitle: '隐私协议',
      privacyModalSubtitle: '平台信息提交-隐私协议',
      privacyModalIntroTitle: '● 隐私权政策',
      privacyModalIntro:
        '我们致力于保护您在使用本网站时所提供的隐私、私人资料以及个人的资料（统称"个人资料"）。使我们在收集、使用、储存和传送个人资料方面符合（与个人资料隐私有关的法律法规）及消费者保护方面的最高标准。为确保您对本网站在处理个人资料上有充分信心，您切要详细阅读及理解隐私政策的条文。 本网站（下称"我们"）尊重并保护用户隐私， 特别是您一旦使用本网站，将被视为接受、同意、承诺和确认本隐私协议；您在自愿下连同所需的同意向我们披露个人资料；您会遵守本隐私政策的任何修改；您同意我们的相关业务人员就您可能会感兴趣的产品和服务与您联络（除非您已经表示不想收到该等讯息）。被收集的个人资料的种类经您的同意、我们会收集、管理和监控个人资料。',
      privacyModalS1Title: '1、 适用范围',
      privacyModalS1:
        '为用户提供更好、更优、更个性化的服务是本网站坚持不懈的追求，也希望通过我们提供的服务可以更方便您的需求。本隐私权政策适用于本网站提供的所有关于信息收集的服务，您访问本网站及使用本网站提供的服务均使用本隐私权政策。',
      privacyModalS2Title: '2、 我们收集哪些信息',
      privacyModalS2:
        '为了向您提供我们的各项服务，您需要提供个人资料信息，其中包括个人资料和不具名的资料，包括但不限于：个人资料（您的姓名、性别、年龄、出生日期、电话号码、传真号码、住址或通讯地址、电子邮箱地址等）。',
      privacyModalS3Title: '3、 我们如何使用收集到的信息',
      privacyModalS3:
        '收集个人资料和不具名的资料目的及用途如下：通过本网站向您提供我们的各项服务；当您使用我们的网站时，能辨认以及确认您的身份；让您使用本网站时得到为您而设的服务；本网站的相关业务人员有需要时可以与您联系；让您在使用本网站时更加方便；您提供给我们的个人资料及不具名资料，只保留到搜集的目的已达到的时候，除非因适用的法律法规之规定而继续保留。个人资料的拥有权及披露在我们网站上所收集的一切资料都由我们所拥有，不会出租或出售给任何无关的第三方。',
      privacyModalS4Title: '4、 我们如何保护信息',
      privacyModalS4:
        '对于个人资料的保护，我们实施妥适的实物、电子、管理的措施来保护和保障您的个人资料的安全。我们尽力确保通过本网站所收集的任何个人资料皆免于任何与我们无关的第三者的滋扰。我们采取的安全措施不限于： 实物措施：存有您个人资料的记录会被存放在有锁的地方 电子措施：存有您个人资料的电脑数据会被存放在受严格登录限制的电脑系统和存储媒体上 管理措施：只有经过我们授权的职员才能接触到您的个人资料，这些职员需要遵守我们个人资料保密的内部规则 若您知悉本网站上有任何安全方面的漏洞，请及时联络我们，使我们可以尽快采取妥适的行动；尽管实施了上述安全措施，我们不能保证资料在互联网上的输送绝对安全，因此我们不能绝对保证您通过本网站提供给我们的个人资料及不具名的资料在一切时候都是安全的。对任何因未经授权而接触您个人资料所发生的事件我们一概不承担责任，于这方面产生或导致的任何损失和损害，我们也不负责赔偿。',
      privacyModalS5Title: '5、 未成年人保护法',
      privacyModalS5:
        '未成年人在无任何家长或监护人批准或同意下向本网站提供了个人资料，请及时联系本网站所公示电话及客服电话等，以确保资料被除去。',
      privacyModalS6Title: '6、 隐私政策的修定与生效',
      privacyModalS6:
        '随着本网站的服务范围扩大，我们可能适时修订《法律声明及隐私权政策》，该等修订构成本《法律声明及隐私权政策》的一部分。为避免您不能及时获知该等修订，请您经常阅读本《法律声明及隐私权政策》。无论何种方式，如您继续使用我们的服务，即表示同意受经修订的本《法律声明及隐私权政策》的约束。',
      privacyModalConfirm: '同意并继续',
    },
  },

  'zh-TW': {
    nav: {
      home: '首頁',
      about: '關於我們',
      services: '業務範圍',
      pricing: '最新報價',
      news: '新聞中心',
      contact: '聯繫我們',
      careers: '人才招聘',
      downloads: '表格下載',
      credentials: '資質榮譽',
      logoText: '首嘉/深圳瀚陽',
    },
    footer: {
      description:
        '首嘉/深圳瀚陽，專注一站式國際物流解決方案，主打印度、歐美、中東等市場的空運和包機定制化服務，同時提供報關、倉儲及供應鏈管理等服務。',
      quickLinks: '快速連結',
      serviceScope: '核心業務',
      contactUs: '聯繫我們',
      domestic: '國際貨運代理',
      international: '空運',
      warehouse: '倉儲配送服務',
      supplyChain: '供應鏈管理',
      address: '廣東省深圳市寶安區福永街道星航中心21A',
      hours: '週一至週日 8:00-18:00',
      copyright: '© 2026 深圳市首嘉運通國際物流有限公司. 保留所有權利.',
      privacy: '隱私政策',
      terms: '服務條款',
      sitemap: '網站地圖',
    },
    home: {
      heroTitle: '專業國際空運物流 值得信賴',
      heroSubtitle:
        '首嘉/深圳瀚陽 — 100% 空運專業運營 · 印度王牌航線 · 獨家Y8全貨機包機，連接印度、歐美及全球核心市場',
      contactNow: '立即諮詢',
      learnMore: '了解更多',
      advantagesTitle: '我們的優勢',
      advantagesSubtitle: '專注國際物流，為您提供高效、可靠的跨境貨運服務',
      fastDelivery: '高效運輸',
      fastDeliveryDesc:
        '印度、歐美、中東、巴基斯坦核心航線，快速直達，確保貨物準時到港',
      safety: '安全保障',
      safetyDesc: '全程保險覆蓋，專業包裝，即時追蹤，確保貨物安全送達',
      pricing: '價格透明',
      pricingDesc: '合理透明的報價體系，大宗貨物享受更多優惠，節省您的物流成本',
      team: '專業團隊',
      teamDesc: '資深國際物流專家團隊，7×24小時為您提供專業諮詢與跟蹤服務',
      coreTitle: '核心業務',
      coreSubtitle: '一站式國際物流解決方案',
      intlFreight: '空運服務',
      intlFreightDesc: '國際航空貨運，專業打包，快速清關，港口到港口配送',
      warehouseService: '報關 · 倉儲 · 供應鏈',
      warehouseDesc:
        '專業報關代理、普通貨物倉儲、裝卸搬運及全流程供應鏈管理服務',
      learnDetails: '了解詳情 →',
      yearsExp: '年空運行業經驗',
      clients: 'BSA合作航司',
      cities: '自有集貨倉庫',
      satisfaction: '年貨運出口量',
      ctaTitle: '準備好開啟您的國際物流之旅？',
      ctaDesc: '聯繫首嘉/深圳瀚陽，獲取專業的物流解決方案和優惠報價',
      getQuote: '獲取報價',
      contactUs: '聯繫我們',
    },
    about: {
      pageTitle: '關於我們',
      pageSubtitle: '專注國際物流，值得信賴的跨境貨運夥伴',
      companyIntro: '公司簡介',
      introP1:
        '深圳市首嘉運通國際物流有限公司（簡稱「首嘉/深圳瀚陽」）為上海瀚陽國際貨運代理有限公司旗下深圳分公司。瀚陽集團成立於2004年，旗下逾300名專業員工，深耕空運領域20餘年，100% 聚焦空運，專注服務北美、歐洲、印巴、澳紐、南非、東南亞等核心市場。',
      introP2:
        '核心業務涵蓋：獨家波音777全貨機包機（Y8，PVG-BOM直飛，每週2班，單班100噸）、BOM 經南京/重慶中轉至芝加哥/洛杉磯/阿姆斯特丹/紐瓦克/華沙轉口 SPA 航線、BSA 航司代理（3U、GI、O3、JG、MU、CX、JL、SQ、D7等）、自有5,000㎡集貨倉庫及保稅卡車服務。分支機構覆蓋深圳、廣州、香港、北京、寧波、杭州、福州及洛杉磯。',
      culture: '企業文化',
      mission: '企業使命',
      missionDesc:
        '成為全球可信賴的物流合作夥伴；追求更高的客戶滿意度；提供及時準確的服務；持續超越，實現互利共贏',
      vision: '企業願景',
      visionDesc:
        '堅持創新與專業，持續提升服務品質，為客戶提供高效、安全、便捷的全球物流解決方案，攜手合作夥伴共創繁榮未來',
      values: '核心價值觀',
      valuesDesc: '誠信經營、專業高效、創新驅動、合作共贏，以客戶價值為核心持續超越',
      history: '發展歷程',
      founded: '福州創立',
      foundedDesc:
        '瀚陽集團在福州成立，扎根空運領域，逐步建立專業化國際物流服務體系',
      expansion: '總部遷至上海',
      expansionDesc:
        '公司總部遷至上海，全面升級運營平台，拓展國際空運業務版圖',
      upgrade: '廣州分公司成立',
      upgradeDesc:
        '廣州分公司正式運營，華南區域業務全面布局，持續拓展國內外空運航線資源',
      scale: '美國分公司成立',
      scaleDesc:
        '洛杉磯分公司成立，正式進入北美市場，構建中美雙向貨運服務能力',
      innovation: '深圳分公司成立',
      innovationDesc:
        '深圳市首嘉運通國際物流有限公司（首嘉/深圳瀚陽）正式成立，深化華南空運及跨境業務，專注印度、歐美、中東等新興市場',
      partnersTitle: '行業協會認證',
      partnersSubtitle: '獲得全球主流貨運行業協會認可，依法合規、誠信經營',
      advantages: '我們的優勢',
      wideNetwork: '🌐 專業航線',
      wideNetworkDesc: '深耕印度、歐美、中東、巴基斯坦航線，覆蓋主要港口，專業高效',
      proTeam: '💼 持證運營',
      proTeamDesc: '持有國際貨運代理、無船承運、報關等資質，合規運營',
      security: '🔒 安全保障',
      securityDesc: '全程保險覆蓋，即時追蹤，確保貨物安全準時到達',
      efficient: '⚡ 一站式服務',
      efficientDesc: '空運、報關、倉儲、供應鏈，全流程一站式處理，提供定制化物流解決方案',
      summitTitle: '國際展會足跡',
      summitSubtitle: '積極參與全球貨代人峰會，拓展國際合作網絡',
      cultureTitle: '團隊風采',
      cultureSubtitle: '凝心聚力，共創未來',
    },
    services: {
      pageTitle: '業務範圍',
      pageSubtitle: '一站式國際物流解決方案',
      intlTitle: '空運服務',
      intlDesc:
        '獨家波音777全貨機包機（Y8）直飛印度孟買（PVG-BOM），每週2班，單班100噸；同時提供 BOM 經南京/重慶中轉至芝加哥、洛杉磯、阿姆斯特丹、紐瓦克、華沙的一單到底 SPA 轉口貿易服務。業務覆蓋北美、歐洲、印巴、澳紐、南非、東南亞等全球核心市場。',
      intlFeatures: [
        '獨家Y8 777全貨機包機（PVG-BOM，100噸/班，每週2班）',
        'BOM→歐美轉口：孟買→南京/重慶→芝加哥/洛杉磯/阿姆斯特丹/華沙',
        'BSA合作航司：3U、GI、O3、JG、MU、CX、JL、SQ、D7等',
        '全球空運集拼服務（Console），多航線平台高效攬貨集貨',
        '一單到底 SPA 轉口貿易，全程保障',
        '覆蓋北美、歐洲、印巴、澳紐、南非、東南亞',
      ],
      warehouseTitle: '報關代理',
      warehouseDesc:
        '持有正規報關資質，提供進出口報關全流程代理服務，包括單證審核、HS編碼歸類、稅費核算及海關申報，確保貨物合規通關，避免延誤與罰款。',
      warehouseFeatures: [
        '進出口報關代理',
        '貨物及技術進出口',
        '無船承運業務（NVOCC）',
        'HS編碼歸類諮詢',
        '稅費預估與優化',
        '全流程單證處理',
      ],
      supplyChainTitle: '倉儲 · 搬運 · 供應鏈',
      supplyChainDesc:
        '提供普通貨物倉儲服務（不含危化品）、裝卸搬運、道路貨物運輸站經營及全鏈路供應鏈管理，助力企業優化庫存、降低成本、提升運營效率。',
      supplyChainFeatures: [
        '普通貨物倉儲（深圳）',
        '海外倉服務',
        'Amazon FBA 頭程物流',
        '裝卸搬運服務',
        '供應鏈管理服務',
        '國內貿易代理',
      ],
      industriesTitle: '經營資質',
      industriesSubtitle: '持有以下合法經營資質，依法合規運營',
      manufacturing: '國際貨運代理',
      ecommerce: '無船承運業務',
      medical: '報關業務',
      food: '國內貨物運輸代理',
      electronics: '供應鏈管理服務',
      clothing: '倉儲 · 集裝箱租賃',
      allServicesTitle: '全部業務範圍',
      allServicesSubtitle: '依法登記的完整經營範圍',
      allServices: [
        '國際貨運代理',
        '國內貨物運輸代理',
        '航空運輸貨物打包服務',
        '國內集裝箱貨物運輸代理',
        '普通貨物倉儲服務（不含危險化學品等需許可審批的項目）',
        '國內貿易代理',
        '裝卸搬運',
        '道路貨物運輸站經營',
        '供應鏈管理服務',
        '物聯網應用服務',
        '互聯網銷售（除銷售需要許可的商品）',
        '集裝箱租賃服務',
        '租賃服務（不含許可類租賃服務）',
        '貨物及技術進出口',
        '報關業務',
        '無船承運業務',
      ],
    },
    pricing: {
      pageTitle: '最新報價',
      pageSubtitle: '透明合理的價格體系，為您節省物流成本',
      noticeTitle: '💡 報價說明',
      notice1:
        '以下報價為參考價格，空運按kg計算',
      notice2: '實際價格因貨物類型、重量、體積、旺季等因素有所調整',
      notice3: '大宗貨物及長期合作客戶享受更多優惠，歡迎聯繫客服獲取專屬報價',
      notice4: '報價不含目的港當地費用，具體以合同為準',
      domestic: '✈️ 空運報價',
      international: '✈️ 空運報價',
      origin: '起運地',
      destination: '目的地/港口',
      refPrice: '參考價格',
      estTime: '預計航程',
      calcTitle: '💰 快速詢價',
      calcDesc: '填寫以下信息，獲取詳細報價',
      originPlaceholder: '起運地（如：深圳）',
      destPlaceholder: '目的地（如：杜拜）',
      weightPlaceholder: '貨物重量（kg）或體積（CBM）',
      goodsType: '貨物類型',
      general: '普通貨物',
      fragile: '易碎品',
      valuable: '貴重物品',
      coldChain: '危險品（需申報）',
      calculate: '立即詢價',
      extraServices: '增值服務',
      packaging: '航空專業打包',
      packagingPrice: '按件報價',
      insurance: '貨物保險',
      insurancePrice: '貨值的0.3%-0.5%',
      pickup: '上門攬貨',
      pickupPrice: '按實際距離報價',
      delivery: '報關代理',
      deliveryPrice: '按票報價',
      customTitle: '需要定制化報價方案？',
      customDesc: '聯繫首嘉/深圳瀚陽專業客服團隊，為您提供最優惠的國際物流方案',
      callNow: '📞 立即致電',
      onlineConsult: '💬 線上諮詢',
    },
    news: {
      pageTitle: '新聞中心',
      pageSubtitle: '了解首嘉/深圳瀚陽最新動態與行業資訊',
      loading: '載入中...',
      noNews: '暫無新聞',
      readMore: '閱讀更多 →',
      backToList: '返回新聞列表',
      notFound: '新聞不存在或已下線',
      searchPlaceholder: '搜尋新聞標題...',
      searchBtn: '搜尋',
      pinned: '置頂',
      categories: {
        '行业资讯': '行業資訊',
        '公司动态': '公司動態',
        '物流知识': '物流知識',
        '政策法规': '政策法規',
      },
    },
    careers: {
      pageTitle: '人才招聘',
      pageSubtitle: '加入首嘉/深圳瀚陽，共同開創國際物流新未來',
      loading: '載入中...',
      noJobs: '暫無招聘信息',
      countUnit: '名',
      nationwide: '全國多地',
      regionLabel: '招聘地區：',
      responsibilities: '崗位職責',
      requirements: '任職要求',
      applyPrefix: '感興趣請將簡歷發送至：',
      applyNote: '郵件主題請注明「應聘崗位 - 姓名 - 意向城市」',
    },
    downloads: {
      pageTitle: '表格下載',
      pageSubtitle: '下載最新運價表及相關報價文件',
      loading: '載入中...',
      noFiles: '暫無可下載文件',
      updatedAt: '更新於',
      preview: '預覽',
      download: '下載',
      previewUnavailable: '預覽功能需要真實文件連結，敬請期待',
      downloadUnavailable: '下載連結暫未配置，敬請期待',
    },
    credentials: {
      pageTitle: '資質榮譽',
      pageSubtitle: '專業資質認證與行業榮譽，值得信賴',
      certsTitle: '企業資質證書',
      certsSubtitle: '持有合法經營資質，依法合規運營',
      honorTitle: '榮譽獎項',
      honorSubtitle: '行業認可，實力見證',
      airlinesTitle: 'BSA 合作航司',
      airlinesSubtitle: '全球知名航空公司首選合作夥伴',
      customersTitle: '主要客戶',
      customersSubtitle: '值得信賴的長期合作夥伴',
      assocTitle: '行業協會會員',
      assocSubtitle: '獲得全球主流貨運行業協會認可',
    },
    // Chat widget
    chat: {
      title: '線上客服',
      welcome: '您好！歡迎諮詢，有什麼可以幫助您的嗎？',
      botReply:
        '非常抱歉，您的問題我暫時無法解答，您可以點擊{link}聯繫人工客服',
      linkText: '轉人工',
      placeholder: '請輸入您的問題…',
      send: '發送',
    },
    contact: {
      pageTitle: '聯繫我們',
      pageSubtitle: '期待為您提供專業的國際物流服務',
      contactInfo: '聯繫方式',
      intro:
        '首嘉/深圳瀚陽專業團隊隨時為您服務，無論您有任何國際物流需求或疑問，歡迎隨時與我們聯繫。',
      hotline: '客服熱線',
      hotlineHours: '週一至週日 8:00-18:00',
      email: '電子郵箱',
      emailReply: '24小時內回覆',
      address: '公司地址',
      addressValue: '廣東省深圳市寶安區福永街道星航中心21A',
      addressNav: '導航搜尋「首嘉/深圳瀚陽物流」',
      onlineService: '線上客服',
      wechat: '微信客服：請聯繫我們獲取',
      wechatScan: '掃碼添加企業微信',
      businessHours: '營業時間',
      weekdays: '週一至週五',
      weekends: '週六至週日',
      holidays: '法定節假日',
      onDuty: '值班服務',
      onlineConsult: '線上諮詢',
      consultDesc: '填寫以下表單，我們會盡快與您聯繫',
      namePlaceholder: '請輸入您的姓名',
      phonePlaceholder: '請輸入您的手機號碼',
      emailPlaceholder: '請輸入您的郵箱地址',
      companyPlaceholder: '請輸入您的公司名稱',
      name: '姓名 *',
      phone: '聯繫電話 *',
      emailLabel: '電子郵箱',
      company: '公司名稱',
      serviceType: '服務類型 *',
      selectService: '請選擇服務類型',
      intlService: '空運服務',
      warehouseService: '報關代理',
      supplyChainService: '倉儲 / 供應鏈管理',
      otherService: '其他諮詢',
      message: '留言內容 *',
      messagePlaceholder:
        '請描述您的物流需求或問題（貨物品名、重量/體積、目的地等）...',
      captchaLabel: '驗證碼 *',
      captchaPlaceholder: '請輸入驗證碼',
      captchaError: '驗證碼錯誤，請重新輸入',
      submit: '提交諮詢',
      submitting: '提交中...',
      successMsg: '感謝您的諮詢！首嘉/深圳瀚陽客服人員會盡快與您聯繫。',
      failMsg: '提交失敗，請稍後重試',
      teamTitle: '聯繫我們的團隊',
      teamAddress: '中國深圳市寶安區福永街道F單元星航中心4號21樓A室',
      location: '公司位置',
      mapLoading: '地圖載入中...',
      mapNote: '實際項目中可整合百度地圖、高德地圖等API',
      mapCompanyName: '深圳市首嘉運通國際物流有限公司/上海瀚陽國際貨運代理有限公司深圳分公司',
      mapAddress: '深圳市寶安區福永街道F單元星航中心4號21樓A室',
      mapAddressLabel: '地址',
      phoneError: '請輸入有效的手機號碼',
      emailError: '請輸入有效的郵箱地址',
      privacyNotice: '請閱讀並同意隱私協議後再提交',
      privacyCheckbox: '我已閱讀並同意',
      privacyLink: '《隱私保護》',
      privacyModalTitle: '隱私協議',
      privacyModalSubtitle: '平台資訊提交-隱私協議',
      privacyModalIntroTitle: '● 隱私權政策',
      privacyModalIntro:
        '我們致力於保護您在使用本網站時所提供的隱私、私人資料以及個人的資料（統稱「個人資料」）。使我們在收集、使用、儲存和傳送個人資料方面符合（與個人資料隱私有關的法律法規）及消費者保護方面的最高標準。為確保您對本網站在處理個人資料上有充分信心，您切要詳細閱讀及理解隱私政策的條文。本網站（下稱「我們」）尊重並保護用戶隱私，特別是您一旦使用本網站，將被視為接受、同意、承諾和確認本隱私協議；您在自願下連同所需的同意向我們披露個人資料；您會遵守本隱私政策的任何修改；您同意我們的相關業務人員就您可能會感興趣的產品和服務與您聯絡（除非您已經表示不想收到該等訊息）。被收集的個人資料的種類經您的同意、我們會收集、管理和監控個人資料。',
      privacyModalS1Title: '1、 適用範圍',
      privacyModalS1:
        '為用戶提供更好、更優、更個性化的服務是本網站堅持不懈的追求，也希望通過我們提供的服務可以更方便您的需求。本隱私權政策適用於本網站提供的所有關於資訊收集的服務，您訪問本網站及使用本網站提供的服務均使用本隱私權政策。',
      privacyModalS2Title: '2、 我們收集哪些資訊',
      privacyModalS2:
        '為了向您提供我們的各項服務，您需要提供個人資料資訊，其中包括個人資料和不具名的資料，包括但不限於：個人資料（您的姓名、性別、年齡、出生日期、電話號碼、傳真號碼、住址或通訊地址、電子郵箱地址等）。',
      privacyModalS3Title: '3、 我們如何使用收集到的資訊',
      privacyModalS3:
        '收集個人資料和不具名的資料目的及用途如下：通過本網站向您提供我們的各項服務；當您使用我們的網站時，能辨認以及確認您的身份；讓您使用本網站時得到為您而設的服務；本網站的相關業務人員有需要時可以與您聯繫；讓您在使用本網站時更加方便；您提供給我們的個人資料及不具名資料，只保留到搜集的目的已達到的時候，除非因適用的法律法規之規定而繼續保留。個人資料的擁有權及披露在我們網站上所收集的一切資料都由我們所擁有，不會出租或出售給任何無關的第三方。',
      privacyModalS4Title: '4、 我們如何保護資訊',
      privacyModalS4:
        '對於個人資料的保護，我們實施妥適的實物、電子、管理的措施來保護和保障您的個人資料的安全。我們盡力確保通過本網站所收集的任何個人資料皆免於任何與我們無關的第三者的滋擾。我們採取的安全措施不限於：實物措施：存有您個人資料的記錄會被存放在有鎖的地方；電子措施：存有您個人資料的電腦數據會被存放在受嚴格登錄限制的電腦系統和存儲媒體上；管理措施：只有經過我們授權的職員才能接觸到您的個人資料，這些職員需要遵守我們個人資料保密的內部規則。若您知悉本網站上有任何安全方面的漏洞，請及時聯絡我們，使我們可以盡快採取妥適的行動；儘管實施了上述安全措施，我們不能保證資料在互聯網上的輸送絕對安全，對任何因未經授權而接觸您個人資料所發生的事件我們一概不承擔責任。',
      privacyModalS5Title: '5、 未成年人保護法',
      privacyModalS5:
        '未成年人在無任何家長或監護人批准或同意下向本網站提供了個人資料，請及時聯繫本網站所公示電話及客服電話等，以確保資料被除去。',
      privacyModalS6Title: '6、 隱私政策的修訂與生效',
      privacyModalS6:
        '隨著本網站的服務範圍擴大，我們可能適時修訂《法律聲明及隱私權政策》，該等修訂構成本《法律聲明及隱私權政策》的一部分。為避免您不能及時獲知該等修訂，請您經常閱讀本《法律聲明及隱私權政策》。無論何種方式，如您繼續使用我們的服務，即表示同意受經修訂的本《法律聲明及隱私權政策》的約束。',
      privacyModalConfirm: '同意並繼續',
    },
  },

  en: {
    nav: {
      home: 'Home',
      about: 'About Us',
      services: 'Services',
      pricing: 'Pricing',
      news: 'News',
      contact: 'Contact',
      careers: 'Careers',
      downloads: 'Downloads',
      credentials: 'Credentials',
      logoText: 'Showjoy/Shenzhen Hanyang',
    },
    footer: {
      description:
        'Showjoy/Shenzhen Hanyang — One-stop international logistics solutions specializing in air freight and charter services for India, Europe & Americas, and Middle East markets, along with customs clearance, warehousing, and supply chain management.',
      quickLinks: 'Quick Links',
      serviceScope: 'Core Services',
      contactUs: 'Contact Us',
      domestic: 'International Freight Forwarding',
      international: 'Air Freight',
      warehouse: 'Warehousing & Distribution',
      supplyChain: 'Supply Chain Management',
      address: 'Room A Floor 21, Xinghang Center, No.2, Xinhua Road, Fuyong Street, Shenzhen, P.R.China. Post code: 518128',
      hours: 'Mon–Sun 8:00–18:00',
      copyright:
        '© 2026 Shenzhen Showjoy International Logistics Co., Ltd. All rights reserved.',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
      sitemap: 'Sitemap',
    },
    home: {
      heroTitle: 'Professional International Air Freight You Can Trust',
      heroSubtitle:
        'Showjoy/Shenzhen Hanyang — 100% Airfreight · India Premier Routes · Exclusive Y8 777 Freighter Charters connecting India, Europe & Americas and global key markets',
      contactNow: 'Contact Us',
      learnMore: 'Learn More',
      advantagesTitle: 'Our Advantages',
      advantagesSubtitle:
        'Focused on international logistics, delivering reliable cross-border freight services',
      fastDelivery: 'Efficient Transport',
      fastDeliveryDesc:
        'Core routes to India, Europe & Americas, Middle East, and Pakistan — fast, direct, on-time port delivery',
      safety: 'Safety Guaranteed',
      safetyDesc:
        'Full insurance coverage, professional packaging, real-time tracking for every shipment',
      pricing: 'Transparent Pricing',
      pricingDesc:
        'Clear and competitive rates, with extra discounts for bulk shipments',
      team: 'Expert Team',
      teamDesc:
        'Senior international logistics specialists available 7×24 for professional consultation',
      coreTitle: 'Core Services',
      coreSubtitle: 'One-Stop International Logistics Solutions',
      intlFreight: 'Air Freight',
      intlFreightDesc:
        'International air cargo with professional packing, fast customs clearance, and port-to-port delivery',
      warehouseService: 'Customs · Warehousing · Supply Chain',
      warehouseDesc:
        'Professional customs brokerage, general cargo warehousing, handling services and full supply chain management',
      learnDetails: 'Learn More →',
      yearsExp: 'Years in Airfreight',
      clients: 'BSA Partner Airlines',
      cities: 'Own Consolidation Warehouse',
      satisfaction: 'Annual Freight Volume',
      ctaTitle: 'Ready to Start Your International Shipping?',
      ctaDesc:
        'Contact Showjoy/Shenzhen Hanyang for professional logistics solutions and competitive quotes',
      getQuote: 'Get a Quote',
      contactUs: 'Contact Us',
    },
    about: {
      pageTitle: 'About Us',
      pageSubtitle: 'Your Trusted Partner for International Logistics',
      companyIntro: 'Company Overview',
      introP1:
        'Shenzhen Showjoy International Logistics Co., Ltd. ("Showjoy/Shenzhen Hanyang") is the Shenzhen branch of Shanghai Hanyang International Express Co., Ltd. Founded in 2004, Hanyang Group employs 300+ professionals with 20+ years of airfreight expertise — 100% focused on airfreight, serving North America, Europe, India, Pakistan, Australia, New Zealand, South Africa, Southeast Asia and beyond.',
      introP2:
        'Core services: Exclusive Boeing 777 freighter charters (Y8, PVG–BOM direct, 100T/flight, 2×/week); transshipment routes BOM–NKG/CKG–ORD/LAX/AMS/EWR/WAW with end-to-end SPA; BSA agency for 3U, GI, O3, JG, MU, CX, JL, SQ, D7 and more; 5,000 m² owned consolidation warehouse; bonded trucking. Branches in Shenzhen, Guangzhou, Hong Kong, Beijing, Ningbo, Hangzhou, Fuzhou, and Los Angeles.',
      culture: 'Corporate Culture',
      mission: 'Our Mission',
      missionDesc:
        'To be the trusted global logistics partner — pursuing higher customer satisfaction, delivering timely and accurate services, and achieving mutual growth through continuous improvement',
      vision: 'Our Vision',
      visionDesc:
        'To maintain innovation and professionalism, continuously improve service quality, and provide efficient, safe, and convenient global logistics solutions — collaborating for a prosperous future',
      values: 'Core Values',
      valuesDesc:
        'Integrity, Professionalism, Innovation, Win-Win — creating maximum value for every client through continuous surpassing',
      history: 'Company Milestones',
      founded: 'Established in Fuzhou',
      foundedDesc:
        'Hanyang Group founded in Fuzhou, beginning 20+ years of deep expertise in professional airfreight services',
      expansion: 'Relocated to Shanghai',
      expansionDesc:
        'Headquarters relocated to Shanghai, upgrading the operational platform and expanding international airfreight business',
      upgrade: 'Guangzhou Branch',
      upgradeDesc:
        'Guangzhou branch established, expanding coverage across South China and growing domestic and international air cargo route resources',
      scale: 'U.S. Branch Established',
      scaleDesc:
        'Los Angeles branch established, entering the North American market and building bidirectional China–U.S. cargo service capabilities',
      innovation: 'Shenzhen Branch',
      innovationDesc:
        'Shenzhen Showjoy International Logistics Co., Ltd. (Showjoy/Shenzhen Hanyang) officially established, deepening South China airfreight and cross-border operations focused on India, Europe & Americas, and Middle East markets',
      partnersTitle: 'Industry Memberships',
      partnersSubtitle: 'Recognized by leading global freight forwarding associations — compliant and trusted',
      advantages: 'Our Strengths',
      wideNetwork: '🌐 Specialized Routes',
      wideNetworkDesc:
        'Deep expertise in India, Europe & Americas, Middle East, and Pakistan routes covering all major ports',
      proTeam: '💼 Licensed & Compliant',
      proTeamDesc:
        'Fully licensed for international freight forwarding, NVOCC, and customs brokerage',
      security: '🔒 Safety First',
      securityDesc:
        'Full insurance coverage and real-time tracking ensuring safe, on-time cargo delivery',
      efficient: '⚡ One-Stop Service',
      efficientDesc:
        'Air freight, customs, warehousing, and supply chain — all under one roof with customized logistics solutions',
      summitTitle: 'Global Events',
      summitSubtitle: 'Actively participating in global freight forwarding summits',
      cultureTitle: 'Team Life',
      cultureSubtitle: 'United in spirit, building the future together',
    },
    services: {
      pageTitle: 'Services',
      pageSubtitle: 'One-Stop International Logistics Solutions',
      intlTitle: 'Air Freight',
      intlDesc:
        'Exclusive Boeing 777 freighter charters (Y8, PVG–BOM direct, 100 tons/flight, 2 flights/week). Also offering end-to-end SPA transshipment trade services via BOM–NKG/CKG to Chicago, Los Angeles, Amsterdam, Newark, and Warsaw. Covering North America, Europe, India, Pakistan, Australia, New Zealand, South Africa, Southeast Asia and more.',
      intlFeatures: [
        'Exclusive Y8 777 Charter (PVG–BOM, 100T/flight, 2×/week)',
        'Tri-shipment: BOM→NKG/CKG→Chicago/LA/Amsterdam/Warsaw',
        'BSA Agent: 3U, GI, O3, JG, MU, CX, JL, SQ, D7 & more',
        'Global air cargo console service — multi-route consolidation platform',
        'End-to-end SPA for transshipment, full coverage',
        'North America, Europe, India, Pakistan, Australia, New Zealand, South Africa, SE Asia',
      ],
      warehouseTitle: 'Customs Clearance',
      warehouseDesc:
        'Licensed customs brokerage providing full-process import and export customs clearance services, including document review, HS code classification, duty calculation, and customs declaration. Ensuring compliant clearance to avoid delays and penalties.',
      warehouseFeatures: [
        'Import & export customs declaration',
        'Goods & technology import/export',
        'NVOCC (Non-Vessel Operating Common Carrier)',
        'HS code classification consulting',
        'Duty estimation & optimization',
        'Full document processing',
      ],
      supplyChainTitle: 'Warehousing · Handling · Supply Chain',
      supplyChainDesc:
        'General cargo warehousing services (excluding hazardous materials), loading/unloading and handling, road freight station operations, and end-to-end supply chain management — helping businesses optimize inventory, cut costs, and improve operational efficiency.',
      supplyChainFeatures: [
        'General cargo warehousing (Shenzhen)',
        'Overseas warehouse services',
        'Amazon FBA first-mile logistics',
        'Loading, unloading & handling',
        'Supply chain management services',
        'Domestic trade agency',
      ],
      industriesTitle: 'Licenses & Qualifications',
      industriesSubtitle:
        'Legally licensed for the following business activities',
      manufacturing: 'Intl. Freight Forwarding',
      ecommerce: 'NVOCC',
      medical: 'Customs Brokerage',
      food: 'Domestic Freight Agency',
      electronics: 'Supply Chain Management',
      clothing: 'Warehousing & Container Leasing',
      allServicesTitle: 'Full Business Scope',
      allServicesSubtitle: 'Complete registered business activities',
      allServices: [
        'International freight forwarding',
        'Domestic freight agency',
        'Air cargo packaging services',
        'Domestic container freight agency',
        'General cargo warehousing (excluding hazardous chemicals and items requiring licensed approval)',
        'Domestic trade agency',
        'Loading, unloading and handling',
        'Road freight station operations',
        'Supply chain management services',
        'IoT application services',
        'Internet sales (excluding items requiring sales license)',
        'Container leasing services',
        'Leasing services (excluding licensed leasing services)',
        'Import and export of goods and technology',
        'Customs declaration services',
        'NVOCC (Non-Vessel Operating Common Carrier)',
      ],
    },
    pricing: {
      pageTitle: 'Pricing',
      pageSubtitle:
        'Transparent and competitive rates to optimize your logistics costs',
      noticeTitle: '💡 Pricing Notes',
      notice1:
        'Reference rates: air freight calculated per kg',
      notice2:
        'Actual prices may vary based on cargo type, weight, volume, season, and surcharges',
      notice3:
        'Bulk shipments and long-term clients enjoy preferential rates — contact us for a custom quote',
      notice4:
        'Rates exclude destination port local charges; final rates subject to contract',
      domestic: '✈️ Air Freight',
      international: '✈️ Air Freight',
      origin: 'Origin',
      destination: 'Destination / Port',
      refPrice: 'Reference Rate',
      estTime: 'Est. Transit Time',
      calcTitle: '💰 Quick Inquiry',
      calcDesc: 'Fill in the details below for a personalized quote',
      originPlaceholder: 'Origin (e.g., Shenzhen)',
      destPlaceholder: 'Destination (e.g., Dubai)',
      weightPlaceholder: 'Weight (kg) or Volume (CBM)',
      goodsType: 'Cargo Type',
      general: 'General Cargo',
      fragile: 'Fragile Items',
      valuable: 'Valuables',
      coldChain: 'Hazardous Goods (declaration required)',
      calculate: 'Get Quote',
      extraServices: 'Value-Added Services',
      packaging: 'Air Cargo Packaging',
      packagingPrice: 'Price per item',
      insurance: 'Cargo Insurance',
      insurancePrice: '0.3%–0.5% of cargo value',
      pickup: 'Cargo Pickup',
      pickupPrice: 'Price by distance',
      delivery: 'Customs Clearance',
      deliveryPrice: 'Price per declaration',
      customTitle: 'Need a Custom Quote?',
      customDesc:
        'Contact the Showjoy/Shenzhen Hanyang team for the best international logistics pricing',
      callNow: '📞 Call Now',
      onlineConsult: '💬 Online Inquiry',
    },
    news: {
      pageTitle: 'News Center',
      pageSubtitle:
        'Latest updates and industry news from Showjoy/Shenzhen Hanyang',
      loading: 'Loading...',
      noNews: 'No news available',
      readMore: 'Read More →',
      backToList: 'Back to News',
      notFound: 'Article not found or unavailable',
      searchPlaceholder: 'Search news by title...',
      searchBtn: 'Search',
      pinned: 'Pinned',
      categories: {
        '行业资讯': 'Industry News',
        '公司动态': 'Company Updates',
        '物流知识': 'Logistics Knowledge',
        '政策法规': 'Policies & Regulations',
      },
    },
    careers: {
      pageTitle: 'Careers',
      pageSubtitle:
        'Join Showjoy/Shenzhen Hanyang and shape the future of global logistics',
      loading: 'Loading...',
      noJobs: 'No openings at this time',
      countUnit: '',
      nationwide: 'Multiple locations',
      regionLabel: 'Regions: ',
      responsibilities: 'Responsibilities',
      requirements: 'Requirements',
      applyPrefix: 'Send your resume to: ',
      applyNote:
        'Please include "Position - Name - Preferred City" in the subject line',
    },
    downloads: {
      pageTitle: 'File Downloads',
      pageSubtitle:
        'Download the latest freight rate sheets and quotation files',
      loading: 'Loading...',
      noFiles: 'No files available',
      updatedAt: 'Updated',
      preview: 'Preview',
      download: 'Download',
      previewUnavailable: 'Preview requires a real file URL — coming soon',
      downloadUnavailable: 'Download link not configured yet — coming soon',
    },
    credentials: {
      pageTitle: 'Credentials & Honors',
      pageSubtitle: 'Professional certifications and industry recognition you can trust',
      certsTitle: 'Business Licenses',
      certsSubtitle: 'Legally licensed and fully compliant',
      honorTitle: 'Awards & Honors',
      honorSubtitle: 'Industry-recognized achievements',
      airlinesTitle: 'BSA Partner Airlines',
      airlinesSubtitle: 'Preferred partner for world-renowned airlines',
      customersTitle: 'Key Customers',
      customersSubtitle: 'Trusted long-term partners',
      assocTitle: 'Association Memberships',
      assocSubtitle: 'Recognized by leading global freight forwarding associations',
    },
    // Chat widget
    chat: {
      title: 'Online Support',
      welcome: 'Hello! Welcome. How can we help you today?',
      botReply:
        "We're sorry, we're unable to answer your question at the moment. Please click {link} to speak with a human agent.",
      linkText: 'Live Agent',
      placeholder: 'Type your question…',
      send: 'Send',
    },
    contact: {
      pageTitle: 'Contact Us',
      pageSubtitle:
        'We look forward to providing you with professional international logistics services',
      contactInfo: 'Contact Information',
      intro:
        'The Showjoy/Shenzhen Hanyang team is always ready to assist. Whether you have shipping inquiries, customs questions, or need a quote, feel free to reach out.',
      hotline: 'Customer Hotline',
      hotlineHours: 'Mon–Sun 8:00–18:00',
      email: 'Email',
      emailReply: 'Reply within 24 hours',
      address: 'Address',
      addressValue: '21A Xinghang Center, Fuyong Street, Bao\'an District, Shenzhen, Guangdong, China',
      addressNav: 'Search "Showjoy/Shenzhen Hanyang Logistics" for navigation',
      onlineService: 'Online Service',
      wechat: 'WeChat: contact us to obtain',
      wechatScan: 'Scan to add corporate WeChat',
      businessHours: 'Business Hours',
      weekdays: 'Monday – Friday',
      weekends: 'Saturday – Sunday',
      holidays: 'Public Holidays',
      onDuty: 'On-duty service',
      onlineConsult: 'Online Inquiry',
      consultDesc:
        'Fill out the form below and we will get back to you shortly',
      namePlaceholder: 'Enter your name',
      phonePlaceholder: 'Enter your phone number',
      emailPlaceholder: 'Enter your email address',
      companyPlaceholder: 'Enter your company name',
      name: 'Name *',
      phone: 'Phone *',
      emailLabel: 'Email',
      company: 'Company',
      serviceType: 'Service Type *',
      selectService: 'Select a service type',
      intlService: 'Air Freight',
      warehouseService: 'Customs Clearance',
      supplyChainService: 'Warehousing / Supply Chain',
      otherService: 'Other Inquiries',
      message: 'Message *',
      messagePlaceholder:
        'Describe your logistics needs (cargo name, weight/volume, destination, etc.)...',
      captchaLabel: 'Verification Code *',
      captchaPlaceholder: 'Enter the code shown',
      captchaError: 'Incorrect code, please try again',
      submit: 'Submit Inquiry',
      submitting: 'Submitting...',
      successMsg:
        'Thank you for your inquiry! The Showjoy/Shenzhen Hanyang team will contact you shortly.',
      failMsg: 'Submission failed. Please try again later.',
      teamTitle: 'Meet Our Team',
      teamAddress: 'Room A Floor 21, Xinghang Center, No.2, Xinhua Road, Fuyong Street, Shenzhen, P.R.China. Post code: 518128',
      location: 'Our Location',
      mapLoading: 'Loading map...',
      mapNote:
        'Map API (e.g., Baidu Maps, Amap) can be integrated in production',
      mapCompanyName: 'Shenzhen Showjoy International Logistics Co.,Ltd/Shanghai Hanyang International Express Co. ,Ltd Shenzhen Branch',
      mapAddress: 'Room A Floor 21, Xinghang Center, Fuyong Street, Shenzhen',
      mapAddressLabel: 'Address',
      phoneError: 'Please enter a valid phone number',
      emailError: 'Please enter a valid email address',
      privacyNotice: 'Please agree to the Privacy Policy before submitting',
      privacyCheckbox: 'I have read and agree to the',
      privacyLink: '《Privacy Policy》',
      privacyModalTitle: 'Privacy Policy',
      privacyModalSubtitle: 'Platform Information Submission - Privacy Policy',
      privacyModalIntroTitle: '● Privacy Policy',
      privacyModalIntro:
        'We are committed to protecting the privacy, personal data, and information (collectively "Personal Data") you provide when using this website, ensuring compliance with applicable privacy laws and the highest standards of consumer protection. Please read this Privacy Policy carefully. By using this website, you are deemed to have accepted, agreed to, and confirmed this Privacy Agreement; you voluntarily disclose Personal Data to us; you agree to comply with any modifications to this policy; and you consent to our staff contacting you about products and services you may be interested in (unless you have indicated otherwise). We will collect, manage, and monitor Personal Data with your consent.',
      privacyModalS1Title: '1. Scope of Application',
      privacyModalS1:
        'It is our persistent pursuit to provide users with better and more personalized services. This Privacy Policy applies to all information-collection services provided by this website. By visiting and using our services, you agree to this Privacy Policy.',
      privacyModalS2Title: '2. Information We Collect',
      privacyModalS2:
        'To provide our services, you may need to supply personal information including, but not limited to: name, gender, age, date of birth, phone number, fax number, mailing or correspondence address, and email address.',
      privacyModalS3Title: '3. How We Use Collected Information',
      privacyModalS3:
        'Personal and anonymous data is collected for the following purposes: to provide our services through this website; to identify and verify your identity; to offer personalized services; to allow our staff to contact you when necessary; and to improve your experience. Data is retained only until the purpose of collection is fulfilled, unless required by applicable law. All data collected on our website is owned by us and will not be rented or sold to unrelated third parties.',
      privacyModalS4Title: '4. How We Protect Your Information',
      privacyModalS4:
        'We implement appropriate physical, electronic, and administrative measures to protect your Personal Data. Physical measures: records containing your data are stored in locked locations. Electronic measures: data is stored on computer systems and media with strict access controls. Administrative measures: only authorized personnel may access your Personal Data, and they are bound by internal confidentiality rules. If you become aware of any security vulnerabilities on this website, please contact us immediately. Despite these measures, we cannot guarantee absolute security of data transmitted over the internet, and we accept no liability for unauthorized access to your Personal Data.',
      privacyModalS5Title: '5. Protection of Minors',
      privacyModalS5:
        'If a minor has submitted Personal Data to this website without parental or guardian approval, please contact us via the published phone or customer service numbers to ensure the data is removed.',
      privacyModalS6Title: '6. Amendments and Effectiveness',
      privacyModalS6:
        'As our services expand, we may revise this Privacy Policy from time to time, and such revisions form part of this Policy. Please review it regularly to stay informed. Continued use of our services constitutes your acceptance of the revised Privacy Policy.',
      privacyModalConfirm: 'Agree and Continue',
    },
  },
};

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState('zh-CN');

  const t = translations[language];

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}
